const productSizeOrder = ["PP/XS", "P/S", "M", "G/L", "GG/XL", "3G/2XL"];

const productSizeRank = new Map(productSizeOrder.map((size, index) => [size, index]));

const getProductSizeRank = (size: string) => productSizeRank.get(size.trim().toUpperCase()) ?? Number.MAX_SAFE_INTEGER;

export const sortProductSizes = (sizes: string[]): string[] =>
  [...sizes].sort((firstSize, secondSize) => {
    const rankDifference = getProductSizeRank(firstSize) - getProductSizeRank(secondSize);

    return rankDifference || firstSize.localeCompare(secondSize, "pt-BR", { numeric: true, sensitivity: "base" });
  });
